import React, { useState } from "react";
import InputField from "~/lib/InputField";
import logo from "~/images/logos/watt-is.png";
import KeyIcon from "~/images/chave.svg?react";
import { useLocation } from "react-router-dom";
import DeviseLayout from "./DeviseLayout";
import useCsrfToken from "~/hooks/useCsrfToken";
import useDeviseFeedback from "~/hooks/useDeviseFeedback";

const PasswordChange = () => {
  useDeviseFeedback({ successMessage: "Palavra-passe alterada com sucesso! Pode agora fazer login." });

  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const resetToken = params.get("reset_password_token");

  const csrfToken = useCsrfToken();

  return (
    <DeviseLayout>
          <form
            action="/users/password"
            method="post"
            className="flex flex-col lg:gap-8 gap-4"
          >
            <input
              type="hidden"
              value={csrfToken}
              name="authenticity_token"
              id="authenticity_token"
            />

            <input
              type="hidden"
              value="put"
              name="_method"
              id="_method"
            />

            <input
              type="hidden"
              value={resetToken}
              name="user[reset_password_token]"
              id="user[reset_password_token]"
            />

            <div className="flex flex-col items-center mb-4">
              <img
                src={logo}
                alt="Watt-IS"
                className="w-40 h-auto mb-20"
              />
              <h2 className="lg:text-4xl text-xl font-normal text-center text-text-black">
                Recuperação da palavra-passe
              </h2>
            </div>

            <div className="flex flex-col gap-2 mx-8 lg:mx-20">
              <InputField
                id="password"
                label="Palavra-passe"
                type="password"
                model={password}
                name="user[password]"
                onChange={setPassword}
                labelStyle="text-left text-[10px] lg:text-xs font-medium text-text-soft-gray"
                inputStyle="focus:ring-1 focus:ring-text-soft-gray px-3 py-1.5 lg:py-2 border border-gray-300 bg-gray-100 rounded-xl text-xs lg:text-sm"
                haveInfo={true}
                infoMsg="Palavra-passe: Incluir números, símbolos, letras maiúsculas e minúsculas. Usar no minimo 12 caracteres."
              />

              <InputField
                id="password"
                label="Confirmação da Palavra-passe"
                type="password"
                model={passwordConfirmation}
                name="user[password_confirmation]"
                onChange={setPasswordConfirmation}
                labelStyle="text-left text-[10px] lg:text-xs font-medium text-text-soft-gray"
                inputStyle="focus:ring-1 focus:ring-text-soft-gray px-3 py-1.5 lg:py-2 border border-gray-300 bg-gray-100 rounded-xl text-xs lg:text-sm"
                haveInfo={true}
                infoMsg="Confirmação da Palavra-passe: Ambas têm de ser iguais."
              />
            </div>

            {/* Botões empilhados e com mesma largura */}
            <div className="flex flex-col items-center gap-4 my-5 w-full">
              <button
                className="relative transition-all w-1/2 py-4 rounded-full bg-btn-tertiary hover:bg-btn-primary text-2xl text-white cursor-pointer flex items-center justify-center lg:block"
                type="submit"
                id="submit_button"
                name="submit_button"
              >
                {/* Texto */}
                <span className="text-center">Alterar Password</span>

                {/* Ícone (mobile: inline, desktop: absoluto à direita) */}
                <KeyIcon className="w-6 h-6 ml-2 lg:ml-0 lg:absolute lg:right-10 lg:top-1/2 lg:-translate-y-1/2 fill-current text-white" />
              </button>

              <a
                href="/users/sign_in"
                className="transition-all w-1/2 py-4 rounded-full hover:bg-orange-sun bg-orange-600 text-2xl text-white text-center cursor-pointer"
              >
                Voltar
              </a>
            </div>
          </form>
    </DeviseLayout>
  );
};

export default PasswordChange;
